<!--  -->
<template>
  <div class="container" v-if="courseInfo">
    <div class="info-box">
      <div class="course-head">
        <p class="course-status">{{courseInfo.status ? '课程已完课' : '课程未完课'}}</p>
        <p class="course-time">上课时间:{{courseInfo.showScheduleTime}}</p>
      </div>
      <div class="master-box">
        <img :src="masterInfo.avatar" alt="" class="master-pic">
        <div class="master-con">
          <p class="course-info"><span class="course-level">level {{courseInfo.lesson.level}}</span> {{courseInfo.lesson.name}}</p>
          <p class="master-name">{{masterInfo.name}}</p>
        </div>
      </div>
      <div class="course-desc">
        <div class="course-desc-head">
          <span class="dot"></span>
          课程知识点
        </div>
        <div class="course-desc-con">
          <h6 class="desc-title">教学目标</h6>
          <ol class="desc-list">
            <li class="desc-item">
              {{courseInfo.lesson.objective}}
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div class="tip-box">
      <p class="tip-con">{{courseInfo.status ? '温馨提示：课程已完成，记得打开学习中心，完成作业哦～' : '温馨提示：预习是个好习惯，打开学习中心就可观看预习视频啦～'}}</p>
      <span class="tip-pic"></span>
    </div>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import { getCourseInfo } from '@/api/account'
export default {
  data () {
    return {
      courseInfo: null,
      studentId: ''
    }
  },
  computed: {
    masterInfo () {
      if (!this.courseInfo) return null
      return this.courseInfo.lecturer
    }
  },
  created () {
    let teachPlanScheduleId = this.$route.query.teachPlanScheduleId
    this.studentId = this.$route.query.studentId || cookie.get('mbstudentid')
    console.log('courseStageId', this.$route)
    this.getCourseDetail(teachPlanScheduleId)
  },
  mounted () {},
  methods: {
    async getCourseDetail (teachPlanScheduleId) {
      let studentId = this.studentId
      let res = await getCourseInfo({ teachPlanScheduleId, studentId })
      if (res.code === 200) {
        this.courseInfo = res.data
      } else {
        this.$notify({ type: 'warning', message: res.message })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.container {
  background: #F0F0F0;
  .info-box {
    width: 750px;
    height: calc(100vh - 160px);
    position: relative;
    margin: 0 auto;
    overflow-y: scroll;
    background: #F0F0F0 url("~@/assets/img/account/course-info-bg.png") no-repeat top left / contain;
  }
  .course-head {
    width: 680px;
    margin: 0 auto;
    padding-top: 80px;
    color: #fff;
    font-weight: bold;
    .course-status {
      font-size: 40px;
    }
    .course-time {
      font-size: 26px;
      margin-top: 24px;
    }
  }
  .master-box {
    width: 680px;
    margin: 46px auto 0;
    background: #fff;
    border-radius: 20px;
    padding: 50px 44px;
    @include flexBox;
    .master-pic {
      flex: 0 0 108px;
      height: 108px;
      border-radius: 20px;
      overflow: hidden;
      background: #F0F0F0;
      margin-right: 52px;
    }
    .master-con {
      flex-grow: 1;
      overflow: hidden;
      .course-info {
        font-size: 30px;
        font-weight: bold;
        color: #878484;
        span {
          // height: 36px;
          display: inline-block;
          font-size: 28px;
          color: #fff;
          padding: 6px 12px;
          border-radius: 25px;
          background: #F85718;
          // line-height: 36px;
          margin-right: 7px;
        }
      }
      .master-name {
        margin-top: 24px;
        color: #333;
        font-size: 42px;
        font-weight: bold;
        @include ellipsis;
      }
    }
  }
  .course-desc {
    width: 680px;
    margin: 32px auto 0;
    background: #fff;
    border-radius: 20px;
    padding: 32px 0 59px;
    .course-desc-head {
      font-size: 27px;
      font-weight: bold;
      color: #333333;
      margin: 0 18px;
      @include flexBox;
      .dot {
        flex: 0 0 9px;
        height: 27px;
        background: #FF9C00;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 13px;
      }
    }
    .course-desc-con {
      padding-left: 42px;
      padding-right: 27px;
      margin-top: 30px;
      .desc-title, .desc-item {
        font-size: 27px;
        line-height: 40px;
        color: #333333;
        font-weight: bold;
      }
    }
  }
  .tip-box {
    display: flex;
    justify-content: center;
    padding-top: 32px;
    // margin-bottom: 30px;
    position: fixed;
    bottom: 33px;
    left: 50%;
    transform: translateX(-50%);
    .tip-con {
      width: 573px;
      height: 97px;
      background: url("~@/assets/img/account/course-info-tip.png") no-repeat left top / contain;
      font-size: 24px;
      color: #fff;
      font-weight: bold;
      line-height: 30px;
      padding: 0 48px 0 23px;
      @include flexBox;
    }
    .tip-pic {
      width: 90px;
      height: 90px;
      border-radius: 50% 50%;
      background: url("~@/assets/img/account/tip-pic.png") no-repeat left top / contain;
      overflow: hidden;
    }
  }
}
</style>
